module.exports = __webpack_public_path__ + "static/home1-footer-a42933e0dbfcfc292d2851be7a137813.png";